export default {
  signin: {
    pageName: "Administrator",
    title: "Authorization",
    userForm: {
      username: {
        placeholder: "Username"
      },
      password: {
        placeholder: "Password"
      },
      language: {
        placeholder: "Language"
      },
      connection: {
        placeholder: "Connection"
      },
      signin: "Sign in"
    },
    alert: 'Input username and password to enter',
    userRules: {
      username: {
        required: "Username is required",
        min: "Username should have more than 4 symbols",
        max: "Username should have less than 24 symbols"
      },
      password: {
        required: "Password is required",
        min: "Password should have more than 4 symbols",
        max: "Password should have less than 24 symbols"
      },
      language: {
        required: "Language is required"
      },
      connection: {
        required: "Connection is required"
      }
    }
  }
};
